export type PgProvider = 'inicis' | 'pay-letter';

export const getPgProvider = (): PgProvider => {
  const provider = import.meta.env.REACT_APP_PG_PROVIDER?.trim().toLowerCase();

  if (provider === 'pay-letter') {
    return 'pay-letter';
  }

  return 'inicis';
};

export const getOneTimePaymentLaunchPath = (): '/payment/inicis' | '/payment/pay-letter' => {
  return getPgProvider() === 'pay-letter' ? '/payment/pay-letter' : '/payment/inicis';
};
